<template>
    <div class="pp-lottery-winnings">
        <div class="pp-lottery-winnings__description" v-if="!hasCalculatedWinnings">Právě probíhá výpočet výher.</div>
        <DsTable>
            <DsRow>
                <DsCell type="th" data-test="table-winnings-1-1">Pořadí</DsCell>
                <DsCell type="th" data-test="table-winnings-2-1">Uhodnuto</DsCell>
                <DsCell type="th" data-test="table-winnings-3-1">Výhra</DsCell>
            </DsRow>
            <DsRow v-for="(winning, index) in results.mainGameWinnings[0]" :key="index">
                <DsCell :data-test="`table-winnings-1-${index + 2}`">{{ index + 1 }}.&nbsp;pořadí</DsCell>
                <DsCell :data-test="`table-winnings-2-${index + 2}`">
                    <div v-if="winning.amount && (winning.wins || hasOtherCountryWins(index))">
                        <strong v-html="StringUtils.formatCurrency(winning.amount)"></strong>
                    </div>
                    <template v-else>–––</template>
                </DsCell>
                <DsCell :data-test="`table-winnings-3-${index + 2}`">
                    <div
                        v-if="winning.amount && (winning.wins || hasOtherCountryWins(index))"
                        v-html="formatWinning(winning.wins, index)"
                    ></div>
                    <template v-else>–––</template>
                </DsCell>
            </DsRow>
        </DsTable>

        <PpAddonWinnings
            v-if="results.addonWinnings"
            :lottery="Lottery.eurojackpot"
            :winnings="results.addonWinnings"
        ></PpAddonWinnings>
        <PpSpecialPrizeWinnings
            :lottery="Lottery.eurojackpot"
            :specialPrizes="results.specialPrizes"
        ></PpSpecialPrizeWinnings>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { PpDraw } from "@/lotteries/services/model/draw";
import { StringUtils } from "@sazka/utils/string-utils";
import PpAddonWinnings from "@/lotteries/product-page/components/results/pp-addon-winnings.vue";
import DsTable from "@sazka/design-system/src/table/ds-table.vue";
import DsRow from "@sazka/design-system/src/table-row/ds-table-row.vue";
import DsCell from "@sazka/design-system/src/table-cell/ds-table-cell.vue";
import PpSpecialPrizeWinnings from "./pp-special-prize-winnings.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

const props = defineProps<{
    results: PpDraw;
}>();

const hasCalculatedWinnings = computed(() => {
    return props.results?.hasCalculatedWinnings;
});

const hasOtherCountryWins = (index: number) => {
    if (index < 3) {
        return !!props.results?.winsByCountry?.[index];
    }

    return false;
};

const formatWinning = (wins: number, index: number) => {
    if (index < 3) {
        return props.results?.winsByCountry?.[index];
    }

    return `Česká republika ${StringUtils.formatNumber(wins)}x`;
};
</script>
